import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  try {
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
      integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    });
  } catch (e) {
    console.warn('Sentry initialization failed:', e);
  }
}

export function setSentryUser(user: { id: string; email: string }): void {
  try {
    Sentry.setUser({ id: user.id, email: user.email });
  } catch {
    // Sentry not initialized or unavailable
  }
}

export function clearSentryUser(): void {
  try {
    Sentry.setUser(null);
  } catch {
    // Sentry not initialized or unavailable
  }
}

export function addSentryBreadcrumb(
  category: string,
  message: string,
  level: 'info' | 'warning' | 'error' = 'info',
  data?: Record<string, unknown>
): void {
  try {
    Sentry.addBreadcrumb({ category, message, level, data });
  } catch {
    // Sentry not initialized or unavailable
  }
}
